import styled from "styled-components";

export const WalletSectionSection = styled.div.attrs({ className: "mt-8" })``;

export const WalletSectionGridLayout = styled.div.attrs({ className: "grid gap-5" })``;
